<div class="container-fluid">
  <div class="card">
    <div class="card-title orange-border">
      <div class="form-group display-inline">
        <div [pTooltip]="canAddQrCode ? getTooltipText : null">
          <button (click)="addQrCode()"
            [disabled]="!canAddQrCode"
            class="navy-btn btn-margin-bottom add-qr-btn">
            Add QR Code
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
        <h3>
          <i class="fa fa-info-circle"></i> No QR codes found. </h3>
        </div>
        <app-search-view>
          <app-qr-search #app [accountType]="AccountType.QR_CODE" [autoRefresh]="true" filters></app-qr-search>
          <table class="table table-hover table-responsive-md table-wrap-sm" grid>
            <div class="sort-field-md">
              <p-select (onChange)="applySorting(selectedSortField?.id, app)"
                [(ngModel)]="selectedSortField"
                [options]="sortFields"
                [showClear]="true"
                class="sort-field"
                optionLabel="name"
              placeholder=" Sort by:"></p-select>
              <em (click)="applySorting(selectedSortField?.id,app)"
              class="{{ isDesc(selectedSortField?.id) ? 'fa fa-sort-desc': isAsc(selectedSortField?.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
            </div>
            <thead>
              <tr>
                <th #description
                  (click)="applySorting(description.id, app)"
                  class="sort-field"
                  id="description"
                  scope="col">Description
                  <em class="{{ isDesc(description.id) ? 'fa fa-sort-desc': isAsc(description.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                </th>
                <th #dateTimeCreated
                  (click)="applySorting(dateTimeCreated.id, app)"
                  class="sort-field"
                  id="dateTimeCreated"
                  scope="col">Date Created
                  <em class="{{ isDesc(dateTimeCreated.id) ? 'fa fa-sort-desc': isAsc(dateTimeCreated.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                </th>
                <th #minAmount
                  (click)="applySorting(minAmount.id, app)"
                  class="sort-field"
                  id="minAmount"
                  scope="col">Minimum Amount
                  <em class="{{ isDesc(minAmount.id) ? 'fa fa-sort-desc': isAsc(minAmount.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                </th>
                <th #maxAmount
                  (click)="applySorting(maxAmount.id, app)"
                  class="sort-field"
                  id="maxAmount"
                  scope="col">Maximum Amount
                  <em class="{{ isDesc(maxAmount.id) ? 'fa fa-sort-desc': isAsc(maxAmount.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                </th>
                <th id="status" scope="col">Status <i class="fa fa-question-circle fa-fw fa-lg"
                pTooltip="{{getQrStatusDescription()}}"></i>
              </th>
              <th class="text-center" scope="col">Edit</th>
              <th class="text-center" scope="col">Download</th>
              <th class="text-center" scope="col">Cancel</th>
            </tr>
          </thead>
          <tbody class="table-hover text-nowrap">
            @for (qrCode of contents; track qrCode) {
              <tr class="cursor-pointer  active-color">
                <td (click)="view(qrCode)">
                  <span class="p-column-title">Description</span>
                  {{ qrCode.description }}
                </td>
                <td (click)="view(qrCode)">
                  <span class="p-column-title">Date Created</span>
                  {{ qrCode.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                </td>
                <td (click)="view(qrCode)">
                  <span class="p-column-title">Minimum Amount</span>
                  {{ getMinimumAmount(qrCode) | toMajor | currency:'R ' }}
                </td>
                <td (click)="view(qrCode)">
                  <span class="p-column-title">Maximum Amount</span>
                  {{ getMaximumAmount(qrCode) | toMajor |currency:'R ' }}
                </td>
                <td (click)="view(qrCode)" class="account_status_col">
                  <span class="p-column-title">Status</span>
                  <span [ngClass]="getAccountStatusUtil().getAccountTextColorClass(qrCode.accountState)">
                    {{ getAccountStatus(qrCode) }}
                  </span>
                </td>
                <td>
                  <div [class]="!getAccountStatusUtil().isPaymentOutstanding(qrCode.accountState) ? 'disabled-btn' : ''"
                    class="text-center">
                    <div class="disabled-tooltip-wrapper"
                      [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot edit QR codes.' : null">
                      <div (click)="editQr(qrCode)"
                        [class.grey-circle-style]="isGuestAdminUser()"
                        class="circle-style">
                        <i class="fa fa-edit fa-lg"></i>
                      </div>
                    </div>
                    <span class="p-column-title account-action-btn">Edit</span>
                  </div>
                </td>
                <td>
                  <div [class]="!getAccountStatusUtil().isPaymentOutstanding(qrCode.accountState) ? 'disabled-btn' : ''"
                    class="text-center">
                    <div class="disabled-tooltip-wrapper"
                      [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download QR codes.': null">
                      <div (click)="downloadQrCode(qrCode)"
                        [class.grey-circle-style]="isGuestAdminUser()"
                        class="circle-style">
                        <i class="fa fa-download fa-lg"></i>
                      </div>
                    </div>
                    <span class="p-column-title account-action-btn">Download</span>
                  </div>
                </td>
                <td>
                  <div [class]="!getAccountStatusUtil().isPaymentOutstanding(qrCode.accountState)? 'disabled-btn' : ''"
                    class="text-center">
                    <div class="disabled-tooltip-wrapper"
                      [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot cancel QR codes.': null">
                      <div (click)="cancel(qrCode)"
                        [class.grey-circle-style]="isGuestAdminUser()"
                        class="circle-style">
                        <i class="fa fa-trash fa-lg"></i>
                      </div>
                    </div>
                    <span class="p-column-title account-action-btn">Cancel</span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-search-view>
    </div>
  </div>
</div>